/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG = true || window.Shopify?.theme?.role === 'development' || window.Shopify?.theme?.role === 'unpublished',
    styles = {
      success: "background:darkgreen;color:white;padding:2px 6px;border-radius:3px",
      error: "background:darkred;color:white;padding:2px 6px;border-radius:3px",
      warning: "background:darkorange;color:white;padding:2px 6px;border-radius:3px",
      info: "background:blue;color:white;padding:2px 6px;border-radius:3px",
      filename: "background:#333;color:#bada55;padding:2px 6px;border-radius:3px;margin-left:4px"
    };

  const getCallerFile = () => {
    try {
      return (new Error().stack.split('\n').find(l => (l.includes('/assets/') || l.includes('/sections/') || l.includes('/snippets/')) && !l.includes('/custom_sitewide.js') || !l.includes('jquery-')) || '')
        .match(/\/(assets|sections|snippets)\/([^:?]+)\??/)?.[2] || '';
    } catch (e) { return ''; }
  };

  const log = (...args) => DEBUG && console.log(...args);

  const collapse = (type, data, title = "Log", status = "info") => {
    if (!DEBUG) return;
    const file = getCallerFile();
    console.groupCollapsed(`%c ${title}${file ? ' %c' + file : ''}`,
      styles[status] || styles.info, file ? styles.filename : '');
    type === "table" ? console.table(data) : console.log(data);
    console.groupEnd();
  };

  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);

const log = window.log;


// ===================== MONEY FORMAT HELPERS =====================
const MoneyUtils = (() => {
  const getMoneyFormat = () => {
    const $cfg = $('#shop-config');
    if ($cfg.length) {
      const cfgMoneyFormat = $cfg.data('money-format');
      const cfgMoneyWithCurrencyFormat = $cfg.data('money-with-currency-format');
      if (cfgMoneyFormat || cfgMoneyWithCurrencyFormat) {
        // Prefer symbol-based format; fall back to code-based if needed
        return cfgMoneyFormat || cfgMoneyWithCurrencyFormat || '{{amount}}';
      }
    }

    const $dataEl = $('#variations-data, #variants-data, #variations-data-global, #variants-data-global');
    if ($dataEl.length) {
      const dataMoneyFormat = $dataEl.data('money-format');
      const dataMoneyWithCurrencyFormat = $dataEl.data('money-with-currency-format');
      return dataMoneyFormat || dataMoneyWithCurrencyFormat || '{{amount}}';
    }

    return '{{amount}}';
  };

  const formatMoney = (amount, formatOverride) => {
    let format = formatOverride || getMoneyFormat();

    if (typeof amount === 'string') amount = amount.replace('.', '');
    if (isNaN(amount) || amount == null) return '0';

    const formatAmount = (val, decimals = 2, thousandsSep = ',', decimalSep = '.') => {
      const num = (val / 100).toFixed(decimals);
      const parts = num.split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep) + (parts[1] ? decimalSep + parts[1] : '');
    };

    const formatPattern = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(formatPattern);
    if (!match) return formatAmount(amount);

    let formatted;
    switch (match[1]) {
      case 'amount':
        formatted = formatAmount(amount, 2);
        break;
      case 'amount_no_decimals':
        formatted = formatAmount(amount, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = formatAmount(amount, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        formatted = formatAmount(amount, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        formatted = formatAmount(amount, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatAmount(amount, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = formatAmount(amount, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatAmount(amount, 2, "'", '.');
        break;
      default:
        formatted = formatAmount(amount, 2);
    }

    return format.replace(formatPattern, formatted);
  };

  const formatMoneyNoTrailingZeros = (amount, formatOverride) => {
    const format = formatOverride || getMoneyFormat();
    const full = formatMoney(amount, format);
    // strip trailing .00 or ,00 only when decimals are all zeros, preserve currency/code
    return full.replace(/([0-9])([.,]0+)(?!\d)/, '$1');
  };

  const getCurrencySymbol = () => {
    const fmt = getMoneyFormat();
    const match = String(fmt).match(/[^\d\s.,]+/g);
    return match && match[0] ? match[0] : '';
  };

  return { getMoneyFormat, formatMoney, formatMoneyNoTrailingZeros, getCurrencySymbol };
})();

window.getMoneyFormat = MoneyUtils.getMoneyFormat;
window.formatMoney = MoneyUtils.formatMoney;
window.MoneyUtils = MoneyUtils;

function getCartUrl() {
  const $cfg = $('#shop-config');
  if ($cfg.length) {
    const url = $cfg.data('cart-url');
    if (url) return url;
  }
  return (window.routes && window.routes.cart_url) || '/cart';
}
function getCheckoutUrl() {
  const $cfg = $('#shop-config');
  if ($cfg.length) {
    const url = $cfg.data('checkout-url');
    if (url) return url;
  }
  const cart = getCartUrl();
  return (cart === '/cart' ? '/checkout' : cart.replace(/\/cart$/, '/checkout')) || '/checkout';
}
window.getCartUrl = getCartUrl;
window.getCheckoutUrl = getCheckoutUrl;

function useCartDrawer() {
  const $cfg = $('#shop-config');
  return $cfg.length && $cfg.data('use-cart-drawer') === true;
}

/**
 * Centralized add-to-cart success handler. When cart drawer is used: opens drawer + builds cart.
 * Otherwise: addFirstOrderGift (if present) or redirect to cart.
 * @param {string} cartUrl
 * @param {Object} [opts] - opts.freeGiftManuallyRemoved: true when user removed the free gift (sets FREE_GIFT_MANUALLY_REMOVED for checkout)
 */
function onAddToCartSuccess(cartUrl, opts = {}) {
  const url = cartUrl || getCartUrl();
  if (useCartDrawer()) {
    if (typeof addFirstOrderGift === 'function') {
      addFirstOrderGift(url, {
        noRedirect: true, onComplete: () => {
          if (typeof window.cart_open === 'function') window.cart_open();
          if (typeof window.cart_build === 'function') window.cart_build();
        }, freeGiftManuallyRemoved: opts.freeGiftManuallyRemoved
      });
    } else {
      if (typeof window.cart_open === 'function') window.cart_open();
      if (typeof window.cart_build === 'function') window.cart_build();
    }
  } else {
    if (typeof addFirstOrderGift === 'function') addFirstOrderGift(url, { freeGiftManuallyRemoved: opts.freeGiftManuallyRemoved });
    else window.location.href = url;
  }
}

window.useCartDrawer = useCartDrawer;
window.onAddToCartSuccess = onAddToCartSuccess;


/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Ensures no unnecessary reinitialization during window resizing.
 *
 * @param {jQuery} carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel(carousel, mobileOptions, breakpoint = 1024, desktopOptions = null) {
  let currentView = null; // Keeps track of the current view ('mobile' or 'desktop')

  function initializeCarousel() {
    const isDesktop = $(window).width() >= breakpoint;

    if (isDesktop) {
      if (currentView !== 'desktop') {
        // Switch to desktop view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy mobile Slick if initialized
        if (desktopOptions) carousel.slick(desktopOptions); // Initialize with desktop options
        currentView = 'desktop';
      }
    } else {
      if (currentView !== 'mobile') {
        // Switch to mobile view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy desktop Slick if initialized
        carousel.slick(mobileOptions); // Initialize with mobile options
        currentView = 'mobile';
      }
    }
  }

  initializeCarousel();
  // Throttle resize to avoid excessive reinitialization
  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initializeCarousel, 250);
  });
}

/**
 * Equalizes title block heights across visible cards in a carousel or grid row.
 *
 * @param {Element} container - Cards wrapper (e.g. `.tp-reviews__cards`)
 * @param {Object} options
 * @param {string} options.cardSelector - Card selector relative to container / slick slides
 * @param {string} [options.titleSelector] - Title element selector inside each card
 * @param {string} [options.titleContainerSelector] - Optional wrapper checked before titleSelector
 * @param {string} [options.resizeNamespace='cardTitleSync'] - jQuery resize event namespace
 */
function bindCardTitleHeightSync(container, options = {}) {
  if (!container) return () => { };

  const {
    cardSelector,
    titleSelector,
    titleContainerSelector,
    resizeNamespace = 'cardTitleSync'
  } = options;

  const getTitleBlock = (card) => {
    if (titleContainerSelector) {
      const titleContainer = card.querySelector(titleContainerSelector);
      if (titleContainer) return titleContainer;
    }
    return titleSelector ? card.querySelector(titleSelector) : null;
  };

  const getCards = () =>
    container.classList.contains('slick-initialized')
      ? [...container.querySelectorAll(`.slick-slide.slick-active ${cardSelector}`)]
      : [...container.querySelectorAll(`:scope > ${cardSelector}`)];

  const syncNow = () => {
    const titleBlocks = getCards().map(getTitleBlock).filter(Boolean);
    if (!titleBlocks.length) return;

    titleBlocks.forEach((el) => { el.style.minHeight = ''; });
    const maxHeight = Math.max(...titleBlocks.map((el) => el.getBoundingClientRect().height));
    if (maxHeight <= 0) return;
    titleBlocks.forEach((el) => { el.style.minHeight = `${maxHeight}px`; });
  };

  let frame = 0;
  const sync = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(syncNow);
  };

  sync();
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(sync).observe(container);
  $(window).on(`resize.${resizeNamespace}`, sync);

  return sync;
}

function slickCardTitleSyncCallbacks(sync) {
  return {
    init: sync,
    reInit: sync,
    afterChange: sync,
    breakpoint: sync
  };
}

/**
 * Adds sticky bar visibility logic below a target section.
 *
 * Example usage:
 *   bindStickyBar('.na_sticky_bar_outer', '.pdp-main', 320);
 *
 * @param {string|HTMLElement|jQuery} stickyBarSelectorOrEl - Selector, jQuery, or HTMLElement for the sticky bar.
 * @param {string|HTMLElement|jQuery} scrollPastSelectorOrEl - Selector, jQuery, or HTMLElement for the element to scroll past.
 * @param {number} [threshold=200] - Optional. Pixels below bottom to trigger, default 200.
 */
function bindStickyBar(stickyBarSelectorOrEl, scrollPastSelectorOrEl, threshold = 200) {
  const $stickyBar = $(stickyBarSelectorOrEl);
  const $scrollPast = $(scrollPastSelectorOrEl);

  if (!$stickyBar.length || !$scrollPast.length) return;

  function checkStickyBar() {
    const rect = $scrollPast[0].getBoundingClientRect();
    const triggersSticky = rect.bottom < (window.innerHeight - threshold);
    $stickyBar.toggleClass('active', triggersSticky);
  }

  $(window).on('scroll resize', checkStickyBar);
  checkStickyBar();
}
window.bindStickyBar = bindStickyBar;

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}

function showCopyNotification() {
  const $n = $('<div class="copy-notification">Copied!</div>').appendTo('body');
  setTimeout(() => $n.css({ opacity: 1, transform: 'translateY(0)' }), 10);
  setTimeout(() => { $n.css({ opacity: 0, transform: 'translateY(20px)' }); setTimeout(() => $n.remove(), 200); }, 1500);
}

function showToast(preset, data = {}) {
  const root = document.getElementById('soldout-toast-root');
  if (!root) return;
  if (root.querySelector('.soldout-toast')) return;

  let template = '';
  if (preset === 'soldout_product') {
    template = root.dataset.template || '%%PRODUCT%% is currently out of stock';
    const productTitle = data.productTitle || 'This product';
    template = template.replace(/%%PRODUCT%%/g, productTitle);
  } else if (preset === 'bundle_builder_no_selection') {
    template = root.dataset.bundleBuilderNoSelectionTemplate || 'Please select at least one product';
  } else if (preset === 'custom') {
    template = (data && typeof data.text === 'string' ? data.text : '').trim();
    if (!template) return;
  } else if (typeof preset === 'string' && preset.trim()) {
    template = preset;
  } else {
    return;
  }

  const message = template;
  const $toast = $('<div class="soldout-toast" role="status"></div>').text(message).appendTo(root);
  requestAnimationFrame(() => $toast.addClass('is-visible'));
  setTimeout(() => {
    $toast.removeClass('is-visible');
    setTimeout(() => $toast.remove(), 250);
  }, 2500);
}
window.showToast = showToast;

function getCarouselButtons(useChevron = false, white = false) {
  const icons = {
    arrow_left: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Left.svg?v=1744058170',
    arrow_right: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Right.svg?v=1744058170',
    arrow_left_white: 'https://cdn.shopify.com/s/files/1/0772/2431/3172/files/chevron-arrow-left-white_e53018af-8763-4f27-b449-25e1056dfd6a.svg?v=1772754719',
    arrow_right_white: 'https://cdn.shopify.com/s/files/1/0772/2431/3172/files/chevron-arrow-right-white_ee2b18fc-7a0e-41fd-b945-97505084e385.svg?v=1772754774',
    chevron_left: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_left.svg?v=1745952252',
    chevron_right: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_right.svg?v=1745952252'
  };

  const leftIcon = useChevron ? icons.chevron_left : (white ? icons.arrow_left_white : icons.arrow_left);
  const rightIcon = useChevron ? icons.chevron_right : (white ? icons.arrow_right_white : icons.arrow_right);

  return {
    prevArrow: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${leftIcon}' alt='arrow'/></button>`,
    nextArrow: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${rightIcon}' alt='arrow'/></button>`
  };
}
window.getCarouselButtons = getCarouselButtons;



$(document).ready(function () {
  $('a[href="#"][title="Copy to Clipboard"]').on('click', function (e) {
    e.preventDefault();
    const text = $(this).data('copy') || $(this).text().trim();
    copyToClipboard(text);
    showCopyNotification();
    log.collapse({ text, parent: $(this).parent().parent() }, 'Copied to Clipboard', 'success');
  });


  const buttons = getCarouselButtons(false);
  const chevronButtons = getCarouselButtons(true);
  const whiteButtons = getCarouselButtons(false, true);

  $('.testimonials__cards').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '40px',
    arrows: true,
    dots: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          centerPadding: '30px'
        }
      }
    ]
  });

  $('.video-reviews__wrapper').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    variableWidth: true,
    prevArrow: chevronButtons.prevArrow,
    nextArrow: chevronButtons.nextArrow,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.pr-item__product-images.gallery-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: whiteButtons.prevArrow,
    nextArrow: whiteButtons.nextArrow,
  });

  $('.product-showcase__products.pdp-description').slick({
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  });

  $('.pdp-main__reviews.multiple').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  /**
   * Keep vertical thumbnails capped to the current gallery height.
   */
  const syncVerticalThumbHeights = () => {
    $('.pdp-main__images-stack[data-layout="vertical"]').each(function () {
      const stack = $(this);
      const gallery = stack.find('.product-images[data-images="all"]').first();
      const thumbs = stack.find('.product-images[data-images="thumbnails"]').first();
      if (!gallery.length || !thumbs.length) return;

      const galleryHeight = Math.round(gallery.outerHeight() || 0);
      if (galleryHeight > 0) {
        thumbs.css('--thumbs-max-height', `${galleryHeight}px`);
      }
    });
  };

  $('.pdp-main__images .product-images[data-images="thumbnails"]').each(function () {
    const container = $(this);
    const layout = String(container.data('layout') || '').toLowerCase();
    const isVertical = layout === 'vertical';
    let isDown = false;
    let startPos;
    let startScroll;

    const getPointerPosition = (event) => {
      if (event.originalEvent.touches && event.originalEvent.touches.length) {
        return isVertical ? event.originalEvent.touches[0].pageY : event.originalEvent.touches[0].pageX;
      }
      return isVertical ? event.pageY : event.pageX;
    };

    const getCurrentScroll = () => isVertical ? container.scrollTop() : container.scrollLeft();
    const setCurrentScroll = (value) => isVertical ? container.scrollTop(value) : container.scrollLeft(value);

    // Prevent image dragging
    container.find('img, video').attr('draggable', false);

    // Mouse events for scrolling
    container
      .on('mousedown', function (e) {
        isDown = true;
        container.addClass('grabbing');
        startPos = getPointerPosition(e);
        startScroll = getCurrentScroll();
        e.preventDefault();
      })
      .on('touchstart', function (e) {
        isDown = true;
        container.addClass('grabbing');
        startPos = getPointerPosition(e);
        startScroll = getCurrentScroll();
      })
      .on('mouseleave mouseup', function () {
        isDown = false;
        container.removeClass('grabbing');
      })
      .on('touchend touchcancel', function () {
        isDown = false;
        container.removeClass('grabbing');
      })
      .on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        const position = getPointerPosition(e);
        const walk = (startPos - position) * 1.5;
        setCurrentScroll(startScroll + walk);
      })
      .on('touchmove', function (e) {
        if (!isDown) return;
        const position = getPointerPosition(e);
        const walk = (startPos - position) * 1.5;
        setCurrentScroll(startScroll + walk);
        e.preventDefault(); // Prevent page scrolling while dragging thumbnails
      });

    // Click on thumbnails to navigate
    container.on('click', 'div:not(.product-image):has(> video, > img, > .product-image[data-type="video"])', function () {
      if (isDown) return; // Don't trigger click when dragging
      $(this).siblings().removeClass('active');
      const index = $(this).addClass('active').data('index');
      $('.pdp-main__images .product-images.slick-initialized[data-images="all"]')
        .slick('slickGoTo', index);
    });
  });

  syncVerticalThumbHeights();
  $(window).on('resize', syncVerticalThumbHeights);
  $('.pdp-main__images .product-images[data-images="all"]').on('setPosition afterChange', syncVerticalThumbHeights);

  $('.draggable-slider').each(function () {
    const slider = $(this);
    let isDown = false;
    let isHover = false;
    let startX, scrollLeft, rafId = null;

    const autoplayEnabled = slider.attr('data-autoplay');
    const speed = parseInt(slider.attr('data-autoplay-speed'), 10) || 5;
    const pxPerSec = speed * 8;
    const imageCount = parseInt(slider.attr('data-image-count'), 10) || 0;
    const cardWidth = parseInt(slider.attr('data-image-width'), 10) || 140;
    const oneCycle = imageCount > 0 ? imageCount * cardWidth : null;
    let scrollRem = 0;

    function tick(now) {
      rafId = requestAnimationFrame(tick);
      if (!autoplayEnabled || isDown || isHover) return;
      const el = slider[0];
      if (el.scrollWidth <= el.clientWidth) return;
      const delta = (now - (tick.last || now)) / 1000;
      tick.last = now;
      const step = pxPerSec * delta + scrollRem;
      const n = Math.floor(step);
      scrollRem = step - n;
      if (n > 0) {
        el.scrollLeft += n;
        if (oneCycle && el.scrollLeft >= oneCycle) el.scrollLeft -= oneCycle;
        else if (el.scrollLeft >= el.scrollWidth - el.clientWidth) el.scrollLeft = 0;
      }
    }
    if (autoplayEnabled) rafId = requestAnimationFrame(tick);

    slider.find('img').attr('draggable', false);
    slider
      .on('mouseenter', () => { isHover = true; })
      .on('mouseleave', () => { isHover = false; })
      .on('mousedown', function (e) {
        isDown = true;
        slider.addClass('grabbing');
        startX = e.pageX;
        scrollLeft = slider.scrollLeft();
        e.preventDefault();
      })
      .on('touchstart', function (e) {
        isDown = true;
        slider.addClass('grabbing');
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = slider.scrollLeft();
      })
      .on('mouseleave mouseup', function () {
        isDown = false;
        slider.removeClass('grabbing');
      })
      .on('touchend touchcancel', function () {
        isDown = false;
        slider.removeClass('grabbing');
      })
      .on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        slider.scrollLeft(scrollLeft + (startX - e.pageX) * 1.5);
      })
      .on('touchmove', function (e) {
        if (!isDown) return;
        slider.scrollLeft(scrollLeft + (startX - e.originalEvent.touches[0].pageX) * 1.5);
        e.preventDefault();
      });
  });



  const pdpImages = $('.pdp-main__images .product-images[data-images="all"]');
  const pdpWhiteArrows = pdpImages.hasClass('arrows-on-thumbnails');
  const pdpImagesOptions = {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: pdpWhiteArrows ? whiteButtons.prevArrow : chevronButtons.prevArrow,
    nextArrow: pdpWhiteArrows ? whiteButtons.nextArrow : chevronButtons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  }
  const pdpImagesDesktopOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: pdpWhiteArrows ? whiteButtons.prevArrow : chevronButtons.prevArrow,
    nextArrow: pdpWhiteArrows ? whiteButtons.nextArrow : chevronButtons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  const ProductShowcase = $('.product-showcase__products:not(.pdp-description)');
  const ProductShowcaseOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  };

  /**
   * Initialize a responsive carousel for each .tp-reviews__cards.
   *
   * By default, only mobile carousel is enabled.
   * For sections with 'desktop-carousel', enable carousel on desktop as well (showing 3 slides if 'column' is present, otherwise 2).
   * This lets each tp-reviews section use its own carousel settings.
   */
  function initTpReviewCarousels() {
    $('.tp-reviews__cards').each(function () {
      const $reviews = $(this);
      const syncTitles = bindCardTitleHeightSync(this, {
        cardSelector: '.tp-reviews__card',
        titleContainerSelector: '.tp-reviews__card-title-container',
        titleSelector: '.tp-reviews__card-title',
        resizeNamespace: 'tpReviewTitles'
      });
      const slickTitleSync = slickCardTitleSyncCallbacks(syncTitles);
      const isColumn = $reviews.hasClass('column');
      const countMobile = isColumn ? 2 : 1;
      const autoplay = $reviews.hasClass('autoplay');
      const autoplaySpeed = (parseInt($reviews.attr('data-speed'), 10) || 5) * 1000;
      const scrollMb = isColumn
        ? (parseInt($reviews.attr('data-slides-to-scroll-mb'), 10) || 1)
        : countMobile;
      const mobileOpts = {
        infinite: true, dots: true, arrows: true,
        autoplay,
        autoplaySpeed,
        prevArrow: chevronButtons.prevArrow,
        nextArrow: chevronButtons.nextArrow,
        slidesToShow: countMobile,
        slidesToScroll: scrollMb,
        on: slickTitleSync,
        responsive: isColumn ? [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              infinite: false
            }
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1.1
            }
          }
        ] : []
      };
      let desktopOpts = null;
      if ($reviews.hasClass('desktop-carousel')) {
        const slickCardsCount = parseInt($reviews.data('slick-cards'), 10) || 3;
        const count = isColumn ? slickCardsCount : 2;
        const scroll = isColumn
          ? (parseInt($reviews.attr('data-slides-to-scroll'), 10) || 1)
          : count;
        desktopOpts = Object.assign({}, mobileOpts, {
          slidesToShow: count,
          slidesToScroll: scroll,
          on: slickTitleSync
        });
      }
      // Only initializes desktop carousel if desktopOpts is defined.
      handleResponsiveCarousel($reviews, mobileOpts, 1024, desktopOpts);
    });
  }
  initTpReviewCarousels();

  function initBundleFeaturedProductsCarousels() {
    $('.bundle-featured-products__cards').each(function () {
      const $cards = $(this);
      const syncTitles = bindCardTitleHeightSync(this, {
        cardSelector: '.bundle-featured-products__card-wrap',
        titleSelector: '.bundle-featured-products__card-title',
        resizeNamespace: 'bundleFeaturedTitles'
      });
      const autoplay = $cards.hasClass('autoplay');
      const autoplaySpeed = (parseInt($cards.attr('data-speed'), 10) || 5) * 1000;
      const mobileOpts = {
        infinite: false,
        dots: true,
        arrows: true,
        variableWidth: true,
        autoplay,
        autoplaySpeed,
        prevArrow: chevronButtons.prevArrow,
        nextArrow: chevronButtons.nextArrow,
        slidesToShow: 1,
        slidesToScroll: 1,
        on: slickCardTitleSyncCallbacks(syncTitles)
      };
      handleResponsiveCarousel($cards, mobileOpts, 768, null);
    });
  }
  initBundleFeaturedProductsCarousels();

  handleResponsiveCarousel(ProductShowcase, ProductShowcaseOptions, 753);
  handleResponsiveCarousel(pdpImages, pdpImagesOptions, 1024, pdpImages.parent().parent().hasClass('images-grid') ? null : pdpImagesDesktopOptions);

  /** Needed because native autoplay + lazy sections often stall on mobile until we call `play()` once the section is in view. */
  if (typeof IntersectionObserver !== 'undefined') {
    const roots = new Set(
      [...document.querySelectorAll('.video-ui__video-wrapper.autoplay')].map((w) => w.closest('.shopify-section') || w)
    );
    const io = new IntersectionObserver((entries) => {
      for (const { isIntersecting, target: t } of entries) {
        const wraps = t.matches('.video-ui__video-wrapper.autoplay') ? [t] : t.querySelectorAll('.video-ui__video-wrapper.autoplay');
        for (const wrap of wraps) {
          const v = wrap.querySelector('video');
          if (!v) continue;
          if (isIntersecting) {
            Object.assign(v, { muted: true, playsInline: true });
            v.play().catch(() => { });
          } else {
            v.pause();
          }
        }
      }
    }, { threshold: 0.2 });
    for (const r of roots) io.observe(r);
  }

  $('[data-video-controls="true"] .video-ui__button.play, .video-ui__video-wrapper[data-video-controls="true"]').click(function () {
    const $videoWrapper = $(this).is('.video-ui__video-wrapper') ? $(this) : $(this).closest('.video-ui__video-wrapper');
    const $video = $videoWrapper.find('video');

    if ($video.length) {
      // Autoplay mode: just toggle mute/unmute, don't pause/play
      if ($videoWrapper.hasClass('autoplay')) {
        const isCurrentlyMuted = $video.get(0).muted;
        if (isCurrentlyMuted) {
          $video.prop('muted', false).prop("volume", 0.5);
          $videoWrapper.addClass('play').find('.video-ui__button.pause').css('display', 'flex');
          $videoWrapper.find('.video-ui__button.play').hide();
        } else {
          $video.prop('muted', true);
          $videoWrapper.removeClass('play').find('.video-ui__button.pause').hide();
          $videoWrapper.find('.video-ui__button.play').css('display', 'flex');
        }
        return;
      }

      // Default mode: existing functionality
      if (!$video.get(0).paused) {
        $video.get(0).pause();
        $videoWrapper.removeClass('play').find('.video-ui__button.pause').hide();
        $videoWrapper.find('.video-ui__button.play').css('display', 'flex');
        return;
      }
      $('.video-ui__video-wrapper[data-video-controls="true"]').each(function () {
        const $otherWrapper = $(this);
        const $otherVideo = $otherWrapper.find('video');
        if ($otherVideo.get(0) !== $video.get(0)) {
          $otherVideo.prop('muted', true).get(0).pause();
          $otherWrapper.removeClass('play').find('.video-ui__button.play').css('display', 'flex');
          $otherWrapper.find('.video-ui__button.pause').hide();
        }
      });

      $video.prop('muted', false).prop("volume", 0.5).get(0).play();
      $(this).is($videoWrapper) ? $videoWrapper.find('.video-ui__button.play').hide() : $(this).hide();
      $videoWrapper.addClass('play').find('.video-ui__button.pause').css('display', 'flex');
    }
  });
  $('[data-video-controls="true"] .video-ui__button.play').click(function (e) {
    e.stopPropagation();
  })


  // Announcement Timer
  function AnnouncementTimer() {
    const timerWrap = $('.announcement__timer, .announcement__timer-labeled');
    if (!timerWrap.length) return;

    let time;
    const timerDate = timerWrap.data('timer-date');
    if (timerDate) {
      const targetTime = new Date(timerDate + "T00:00:00"); // Local midnight of the given date
      time = Math.floor((targetTime - new Date()) / 1000); // Time difference in seconds
    } else {
      time = parseInt(timerWrap.data('time'), 10);
    }

    if (time <= 0) return timerWrap.hide(); // Ensures valid countdown

    const calculateTime = () => {
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;
      return { hours, minutes, seconds };
    };

    const updateSimple = ({ hours, minutes, seconds }) => {
      timerWrap.find('.timer').text([hours, minutes, seconds]
        .map(v => v.toString().padStart(2, '0')).join(':'));
    };
    const updateLabeled = ({ hours, minutes, seconds }) => {
      console.log(hours, minutes, seconds);
      timerWrap.find('.hours').text(hours.toString().padStart(2, '0'));
      timerWrap.find('.minutes').text(minutes.toString().padStart(2, '0'));
      timerWrap.find('.seconds').text(seconds.toString().padStart(2, '0'));
    };

    const update = () => {
      if (time < 0) return timerWrap.hide();
      timerWrap.hasClass('announcement__timer-labeled') ? updateLabeled(calculateTime()) : updateSimple(calculateTime());
      time--;
    };

    update();
    setInterval(update, 1000);
  }

  // Easter Banner Timer
  function EasterBannerTimer(usePDT = false) {
    const timerElement = $('.easter-banner__timer-value');
    if (!timerElement.length) return;

    const endDate = new Date('April 25, 2025 23:59:59').getTime();

    function updateTimer() {
      // If using PDT, adjust time by calculating PDT from UTC
      const now = usePDT
        ? new Date().getTime() + (new Date().getTimezoneOffset() * 60000) - (7 * 3600000)
        : new Date().getTime();

      const timeLeft = endDate - now;
      if (timeLeft <= 0) return timerElement.parent().hide();

      const days = Math.floor(timeLeft / 86400000);
      const hours = Math.floor(timeLeft % 86400000 / 3600000);
      const minutes = Math.floor(timeLeft % 3600000 / 60000);
      const seconds = Math.floor(timeLeft % 60000 / 1000);

      timerElement.text(days > 0
        ? `${days} Days ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        : `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // HH Collapse Flex Percentage Stats - animate circle fill and counter
  function HHCollapseFlexPercentageStats() {
    const roots = document.querySelectorAll('.hh_collap_percentage_stats:not([data-percentage-stats-init])');
    if (!roots.length) return;

    const CIRCLE_RADIUS = 34;
    const CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;
    const DURATION = 1000;

    const animateCircle = (circle) => {
      if (circle.dataset.animated === 'true') return;
      circle.dataset.animated = 'true';

      const target = Math.max(0, Math.min(100, Number(circle.dataset.percentage || 0)));
      const valueEl = circle.querySelector('.hh_collap_percentage_circle-value');
      const fillEl = circle.querySelector('.hh_collap_percentage_circle-fill');
      if (!fillEl) return;

      fillEl.style.strokeDasharray = `${CIRCUMFERENCE}`;
      fillEl.style.strokeDashoffset = `${CIRCUMFERENCE}`;

      const startTime = performance.now();

      const step = (now) => {
        const progress = Math.min((now - startTime) / DURATION, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = target * eased;

        fillEl.style.strokeDashoffset = `${CIRCUMFERENCE * (1 - current / 100)}`;
        if (valueEl) valueEl.textContent = `${Math.round(current)}%`;

        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    const animateRoot = (root) => {
      root.dataset.percentageStatsInit = 'true';
      for (const circle of root.querySelectorAll('.hh_collap_percentage_circle')) {
        animateCircle(circle);
      }
    };

    const resetRoot = (root) => {
      root.removeAttribute('data-percentage-stats-init');
      for (const circle of root.querySelectorAll('.hh_collap_percentage_circle')) {
        circle.dataset.animated = 'false';
        const valueEl = circle.querySelector('.hh_collap_percentage_circle-value');
        const fillEl = circle.querySelector('.hh_collap_percentage_circle-fill');
        if (valueEl) valueEl.textContent = '0%';
        if (fillEl) fillEl.style.strokeDashoffset = `${CIRCUMFERENCE}`;
      }
    };

    if (!('IntersectionObserver' in window)) {
      for (const root of roots) animateRoot(root);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          animateRoot(entry.target);
        } else {
          resetRoot(entry.target);
        }
      }
    }, { threshold: 0.35 });

    for (const root of roots) observer.observe(root);
  }
  HHCollapseFlexPercentageStats();

  // HH Collapse Flex Progress Bars - Compact, run once per bar
  function HHCollapseFlexProgressBars() {
    const bars = $('.hh_collap_progress_bar_fill');
    if (!bars.length) return;
    const onScroll = () => {
      bars.each(function () {
        if (!this.classList.contains('filled') && this.getBoundingClientRect().top < window.innerHeight && this.getBoundingClientRect().bottom > 0) {
          this.classList.add('filled');
        }
      });
      if ($('.hh_collap_progress_bar_fill:not(.filled)').length === 0)
        $(window).off('scroll resize', onScroll);
    };
    $(window).on('scroll resize', onScroll); onScroll();
  }
  HHCollapseFlexProgressBars();

  // Initialize section code
  if ($('.announcement__timer, .announcement__timer-labeled').length > 0) {
    AnnouncementTimer();
    $('.announcement__text a').on('click', function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      copyToClipboard(text);
      log.collapse(text, 'Copied to Clipboard');
    });
  }

  // Initialize Easter Banner Timer
  if ($('.easter-banner__timer-value').length > 0) {
    // Pass true to use PDT timezone, false or nothing to use local time
    EasterBannerTimer(true);
  }

  $('.AddToCart').on('click', function (e) {
    e.preventDefault();
    const cartUrl = getCartUrl();
    const variantId = $(this).data('id');
    $.post(cartUrl + '/add.js', {
      items: [{ id: variantId, quantity: 1 }]
    }, function (response) {
      log.collapse(response, 'Added to Cart', 'success');
      if (window.onAddToCartSuccess) window.onAddToCartSuccess(cartUrl);
      else window.location.href = cartUrl;
      // theme.ajaxCart.update();
    }).fail(function (response) {
      log.collapse(response, 'Add to Cart Failed', 'error');
    });
  });

  function FAQGroups() {
    const showGroup = (handle, $root) => {
      const $groups = $root.find('.faq-split__faq-group');
      $groups.removeClass('active').filter(`[data-handle="${handle}"]`).addClass('active');

      const $panels = $root.find('.faq-split__group-panel');
      if ($panels.length) {
        $panels.each(function () {
          const panelHandle = $(this).attr('data-handle');
          $(this).toggleClass('hidden', handle !== 'all' && panelHandle !== handle);
        });
        return;
      }

      $root.find('.accordion-item').each(function () {
        if (handle === 'all') {
          $(this).removeClass('hidden');
        } else {
          $(this).toggleClass('hidden', $(this).attr('data-handle') !== handle);
        }
      });
    };

    $('.faq-split').each(function () {
      const $root = $(this);
      const $groups = $root.find('.faq-split__faq-group');
      if (!$groups.length) return;

      let $preselected = $groups.filter('.active').first();
      if (!$preselected.length) {
        const mode = $root.attr('data-preselected-group') || 'first';
        if (mode === 'all') {
          $preselected = $groups.filter('[data-handle="all"]').first();
        }
        if (!$preselected.length) {
          $preselected = $groups.not('[data-handle="all"]').first();
        }
        if (!$preselected.length) {
          $preselected = $groups.first();
        }
      }

      showGroup($preselected.attr('data-handle'), $root);

      $groups.off('click.faqGroups').on('click.faqGroups', function () {
        showGroup($(this).attr('data-handle'), $root);
      });
    });
  }
  FAQGroups();

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion.accordion--expand-first > .accordion-item:first-child").addClass("is-active");
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    if ($(this).hasClass("is-active")) {
      $(this).removeClass("is-active").children(".accordion-panel").slideUp("ease-out");
    } else {
      $(this).addClass("is-active").children(".accordion-panel").slideDown("ease-out");
    }
  });

  $('.hh_collapsible_tab').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
  });

  $('.na_footer_accordion_trigger').click(function () {
    $(this).toggleClass('active');
    $(this).closest('.na_footer_menu_block').find('.na_footer_menu_inner').slideToggle();
  });

  // ------------------------ Product Options --Custom Dropdown -----------------------------------
  // -- USED IN: Cart Drawer items, Cart Drawer upsells, Cart Drawer gift popup, PDP Main, PDP Bundle --
  $('.main-select__label').on('click', function (e) {
    e.stopPropagation();
    const $select = $(this).closest('.main-select');
    $('.main-select').not($select).removeClass('open');
    $select.toggleClass('open');
  });

  // Update button text when an option is selected
  $('.main-select__item').on('click', function (e) {
    const $this = $(this);
    if ($this.hasClass('soldout')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    const selectedText = $this.find('.item-label').text().trim();
    const $select = $this.closest('.main-select');
    $select.find('.main-select__item').removeAttr('data-selected');
    $this.attr('data-selected', 'true');
    $select.find('.main-select__label p').text(selectedText);
    $this.hasClass('color') && $select.find('.main-select__label .main-color-swatch div').attr('style', $this.find('.main-color-swatch div').attr('style'));
    $select.removeClass('open');
  });

  // Smart dropdown positioning to prevent viewport overflow
  $('.main-select__label').on('click', function () {
    const $select = $(this).closest('.main-select');
    const $menu = $select.find('.main-select__menu');

    $menu.removeClass('above right');

    setTimeout(() => {
      const menuRect = $menu[0].getBoundingClientRect();
      const { innerHeight: vh, innerWidth: vw } = window;

      if (menuRect.bottom > vh - 20) $menu.addClass('above');
      if (menuRect.right > vw - 20) $menu.addClass('right');
    }, 10);
  });

  // Close dropdown when clicking outside
  $(document).on('click', (e) => {
    const $target = $(e.target);
    const $clickedItem = $target.closest('.main-select__item');

    // Don't close if clicking on a soldout item
    if ($clickedItem.length && $clickedItem.hasClass('soldout')) return;

    // Close if clicking outside the dropdown
    if (!$target.closest('.main-select').length) {
      $('.main-select').removeClass('open');
    }
  });

  // ----------------------- Handle Modals -----------------------
  let contentModalScrollY = null;

  function lockBodyScroll() {
    const scrollY = window.scrollY;
    $('body').css('top', `-${scrollY}px`).addClass('no-scroll');
    $('#main, #MainContent').css({
      'z-index': '21',
      'position': 'relative'
    });
    return scrollY;
  }

  function unlockBodyScroll(scrollY) {
    $('body').removeClass('no-scroll').css('top', '');
    $('#main, #MainContent').css({
      'z-index': 'unset',
      'position': 'unset'
    });
    if (scrollY != null) setTimeout(() => window.scrollTo({ top: scrollY, behavior: 'instant' }), 10);
  }

  function initContentModals() {
    $(document).on('click', '[data-content-modal-trigger]', function (e) {
      e.preventDefault();
      const modalId = $(this).attr('data-content-modal-trigger');
      const $modal = $('#' + modalId);
      if (!$modal.length) return;
      contentModalScrollY = lockBodyScroll();
      $modal.addClass('active').attr('aria-hidden', 'false').fadeIn();
    });

    $(document).on('click', '.modal-wrapper .modal-close, .modal-wrapper .modal-overlay', function () {
      const $modal = $(this).closest('.modal-wrapper');
      if (!$modal.find('.modal-content--popup').length) return;
      $modal.removeClass('active').attr('aria-hidden', 'true').fadeOut();
      unlockBodyScroll(contentModalScrollY);
    });
  }

  initContentModals();

  function handleModal(modalSelector, triggerSelector) {
    const $modal = $(modalSelector);
    let lastScrollY = null;

    // Open modal
    $(triggerSelector).on('click', function () {
      lastScrollY = lockBodyScroll();
      $modal.addClass('active').attr('aria-hidden', 'false').fadeIn();
    });

    // Close modal
    $('.modal-close, .modal-overlay').on('click', function () {
      $modal.removeClass('active').attr('aria-hidden', 'true').fadeOut();
      unlockBodyScroll(lastScrollY);
    });
  }
  // Initialize modals
  handleModal('#nutrition-table-modal', '.pdp-main__nutrition-table-btn, .pdp-main-bundle__nutrition-table-btn');
  handleModal('#pdp-main-popup', '.pdp-main-bundle__product-learn-more, .pdp-main-bundle__gift');
  handleModal('#gift-card-terms-modal', '.product-form__gift-card-terms');

})
